<script>
  import AppPageHeader from '../../../components/main/PageHeader'
  import EmptyList from '../../../components/list/EmptyList'

  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import * as $contratoService from '../services/contratoService'

  import {Chart} from 'highcharts-vue'
  import exportingInit from 'highcharts/modules/exporting'

  import bus from '@utils/bus'
  import {mapGetters} from 'vuex'

  import {isEmpty} from 'lodash'

  export default {
    components: {AppPageHeader, EmptyList},
    mounted () {
      this.carregarContratos()
    },
    data () {
      return {
        tab: 'grafico',
        contrato: null,
        periodo: null,
        contratos: [],
        periodos: [],
        matriculas: [],
        mostrarModalPdf: false,
        mostrarModalDetalheFrequencia: false,
        mostrarModalDetalheNotas: false,
        mostrarModalGrafico: false,
        nomeDisciplina: null,
        refDisciplina: null,
        refMatricula: null,
        pdfBase64: '',
        infoDetalheFrequencia: 'Detalhes da Frequência',
        frequencias: [],
        competencias: [],
        notasMatriculasAvaliacoes: [],
        mostarNota: [],
        descAvaliacao: [],
        chartOptionsMedia: {
          chart: {
            type: 'bar',
            spacingBottom: 20,
            spacingTop: 10,
            spacingLeft: 10,
            spacingRight: 10
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: ['Avaliaçoẽs']
          },
          yAxis: {
            min: 0,
            max: 10,
            stackLabels: {
              enabled: true,
              formatter: function () {
                return '<br><span align="center">' + this.total + '<br>Média Parcial</span>'
              },
              style: {
                fontWeight: 'bold',
                fontSize: '12px',
                align: 'center',
                color: (Chart.theme && Chart.theme.textColor) || 'black'
              }
            }
          },
          tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y}<br/>Média Geral: {point.stackTotal}'
          },
          plotOptions: {
            series: {
              stacking: 'normal',
              dataLabels: {
                enabled: true,
                color: (Chart.theme && Chart.theme.dataLabelsColor) || 'white'
              }
            }
          },
          series: []
        },
        chartOptionsAvaliacoes: {
          chart: {
            type: 'column'
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: []
          },
          yAxis: [{
            min: 0,
            max: 3.5,
            title: {
              text: ''
            }
          }, {
            title: {
              text: ''
            },
            opposite: true
          }],
          legend: {
            shadow: false
          },
          tooltip: {
            shared: true
          },
          plotOptions: {
            column: {
              grouping: false,
              shadow: false,
              borderWidth: 0
            },
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: []
        }
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      frequenciasVazio: function () {
        return isEmpty(this.matriculas)
      },
      posGraduacao () {
        if (this.contrato) {
          if (this.matriculas.length) {
            return this.matriculas[0].ref_tipo_formacao === 3 ||
              this.matriculas[0].ref_tipo_formacao === 4
          }
        }
        return false
      },
      mostrarNotas () {
        console.log(this.notasMatriculasAvaliacoes)
      }
    },
    methods: {
      carregarContratos () {
        $contratoService.buscarContratos()
          .then((response) => {
            this.contratos = [...this.contratos, ...response]
            if (this.contratos.length === 1) {
              this.contrato = this.contratos[0].id
              this.selecionaContrato(this.contrato)
            } else {
              bus.$emit('hide-loader')
            }
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      selecionaContrato (value) {
        this.periodo = null
        this.periodos.splice(0)
        this.matriculas.splice(0)
        if (value) {
          bus.$emit('show-loader')
          $contratoService.buscarPeriodos(value)
            .then((response) => {
              this.periodos = [...this.periodos, ...response]
              if (this.periodos.length > 0) {
                this.periodo = this.periodos[0].periodo
                this.selecionaPeriodo(this.periodo)
              }
              bus.$emit('hide-loader')
            })
            .catch(e => {
              bus.$emit('hide-loader')
              console.log(e)
            })
        }
      },
      selecionaPeriodo (value) {
        if (value) {
          bus.$emit('show-loader')
          this.matriculas.splice(0)
          let data = {periodo: value}
          restfulService.post('contrato', 'matriculas-periodo', this.contrato, data)
            .then((response) => {
              this.matriculas = [...this.matriculas, ...response]
              this.matriculas.forEach(item => {
                let matricula = 'M' + String(item.ref_matricula)
                this.notasMatriculasAvaliacoes[matricula] = {
                  avaliacoes: [],
                  dados: null
                }
              })
              this.mostrarModuloCompetencias()
              bus.$emit('hide-loader')
            })
            .catch(e => {
              bus.$emit('hide-loader')
              console.log(e)
            })
        } else {
          this.matriculas.splice(0)
        }
      },
      mostrarPlanoEnsino (item) {
        bus.$emit('show-loader')
        restfulService.get('disciplina', 'pdf', item.ref_turma)
          .then((response) => {
            if (response.base64) {
              this.pdfBase64 = 'data:application/pdf;base64,' + response.base64
              this.mostrarModalPdf = true
            } else {
              notifyService.warning({
                title: 'Atenção',
                message: 'Plano de ensino não disponível para essa disciplina'
              })
            }
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      mostrarDetalheFrequencia (refTurma, refDisciplina, nomeDisciplina) {
        bus.$emit('show-loader')
        this.nomeDisciplina = nomeDisciplina
        this.refDisciplina = refDisciplina
        let data = {
          ref_turma: refTurma,
          periodo: this.periodo
        }
        restfulService.post('frequencia', 'detalhes', null, data)
          .then((response) => {
            if (response) {
              this.mostrarModalDetalheFrequencia = true
              this.frequencias = [...[], ...response]
            } else {
              notifyService.warning({
                title: 'Atenção',
                message: 'Não foi possível detalhar a sua frequência'
              })
            }
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      async mostrarModuloCompetencias () {
        let data = {
          ref_periodo: this.periodo,
          ref_contrato: this.contrato
        }
        await restfulService.post('contrato', 'matriculas-competencias', null, data)
          .then((response) => {
            this.competencias = response
            Object.entries(this.competencias.notas_matriculas_individuais).forEach(([key, value]) => {
              Object.entries(value).forEach(([key, items]) => {
                Object.values(items).forEach((item) => {
                  this.descAvaliacao[key] = item.desc_prova
                })
              })
            })
          })
      },
      async mostraModuloCompetencias (refMatricula) {
        let data = {
          ref_periodo: this.periodo,
          ref_contrato: this.contrato
        }
        this.chartOptionsMedia.series.splice(0)
        this.chartOptionsAvaliacoes.series.splice(0)
        let series = []
        let categories = []
        let seriesAvaliacoes = []
        let notas = []
        let pesos = []
        await restfulService.post('contrato', 'matriculas-competencias', null, data)
          .then((response) => {
            if (response) {
              if (Number.isInteger(refMatricula)) {
                this.refMatricula = refMatricula
                this.mostrarModalDetalheNotas = true
              } else {
                this.mostrarModalGrafico = true
              }
              this.competencias = response
              this.competencias.avaliacoes.forEach(item => {
                if (item) {
                  let serie = {
                    name: item.desc_tipo_prova + ' (' + item.peso + ')',
                    data: [item.media]
                  }
                  notas.push(item.media)
                  pesos.push(parseFloat(item.peso))
                  categories.push(item.desc_tipo_prova + ' (' + item.peso + ')')
                  series.push(serie)
                }
              })
              seriesAvaliacoes = [{
                name: 'PESO',
                data: [...pesos],
                color: 'rgba(237, 161, 85,.5)',
                pointPadding: 0.3,
                pointPlacement: -0.2
              }, {
                name: 'AVALIAÇÃO',
                data: [...notas],
                color: 'rgba(247,163,92,1)',
                pointPadding: 0.4,
                pointPlacement: -0.2
              }]
              if (Number.isInteger(refMatricula)) {
                let matricula = 'M' + String(refMatricula)
                this.notasMatriculasAvaliacoes[matricula].avaliacoes = []
                this.competencias.avaliacoes.forEach(item => {
                  let dadosMatricula = item.matriculas.find(matriculaDados => {
                    return matriculaDados.ref_matricula === String(refMatricula)
                  })
                  if (dadosMatricula) {
                    this.notasMatriculasAvaliacoes[matricula].dados = dadosMatricula
                  }
                  let avaliacoes = []
                  let notasAvalacao = []
                  for (const notasMatricula in item.notas_matriculas[refMatricula]) {
                    notasAvalacao = [...notasAvalacao, item.notas_matriculas[refMatricula][notasMatricula]]
                  }
                  if (notasAvalacao.length > 0) {
                    avaliacoes = [{
                      ref_matricula: refMatricula,
                      avaliacao: item.desc_tipo_prova,
                      notas: notasAvalacao,
                      turma: dadosMatricula
                    }]
                    this.notasMatriculasAvaliacoes[matricula].avaliacoes.push(avaliacoes)
                  }
                })
              }
            } else {
              notifyService.warning({
                title: 'Atenção',
                message: 'Não foi possível detalhar a sua notas'
              })
            }
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
        this.chartOptionsAvaliacoes.xAxis.categories = categories
        this.chartOptionsAvaliacoes.series = [...seriesAvaliacoes]
        this.chartOptionsMedia.series = [...series]
        exportingInit(Chart)
      }
    }
  }
</script>

<template>
    <div class="page-content">
        <app-page-header/>
        <div class="box">
            <v-container fluid grid-list-md>
                <v-layout row wrap>
                    <v-flex sm6 xs12>
                        <v-select :items="contratos"
                                  v-model="contrato"
                                  label="Curso"
                                  no-data-text="Nenhum curso encontrado"
                                  clearable
                                  @input="selecionaContrato"
                                  item-value="id"
                                  item-text="descricao"/>
                    </v-flex>
                    <v-flex sm6 xs12>
                        <v-select :items="periodos"
                                  v-model="periodo"
                                  label="Período"
                                  no-data-text="Nenhum períodos encontrado"
                                  clearable
                                  @input="selecionaPeriodo"
                                  item-value="periodo"
                                  item-text="descricao"/>
                    </v-flex>
                </v-layout>
            </v-container>
            <empty-list v-if="frequenciasVazio"
                        title="Selecione o Curso/Período"
                        description="As disciplinas serão mostradas conforme o período selecionado"/>
            <div v-if="!frequenciasVazio">
                <h3 class="page-content-title">
                  Disciplinas 
                  <template v-for="itemContrato in contratos">
                        <v-btn fab dark small color="primary col-2" v-if="itemContrato.id == contrato && itemContrato.curriculo.fl_curriculo_competencias && itemContrato.curriculo.ref_curriculo_modelo_avaliacao != 3" size="x-large" @click="mostraModuloCompetencias">
                        <i class="fas fa-chart-bar"></i>
                      </v-btn>
                  </template>
                </h3>
                <div class="disciplinas-lista">
                    <div class="disciplina" v-for="item in matriculas">
                        <h3>{{item.ref_disciplina}} - {{item.disciplina}}</h3>
                        <p><strong>Professor:</strong> {{item.professores || '-'}}</p>
                        <p><strong>Situação:</strong> {{item.estado}}</p>
                        <p><strong>Turno:</strong> {{item.turno || '-'}}</p>
                        <p>
                            <strong>Plano de Ensino:</strong>
                            <a href="#" @click="mostrarPlanoEnsino(item)" class="plano-ensino-link">
                                <i class="fas fa-file-pdf"></i>
                                <span>Visualizar</span>
                            </a>
                        </p>
                        <div class="dados">
                            <div class="conteudo">
                                <div class="frequencia-dados">
                                    <div class="detalhe-frequencia" id="detalhe-frequencia" :title="infoDetalheFrequencia">
                                        <a href="#" @click="mostrarDetalheFrequencia(item.ref_turma, item.ref_disciplina, item.disciplina)" class="presencas">
                                            <i class="fas fa-plus-circle"></i>
                                        </a>
                                    </div>
                                    <em>Presenças</em>
                                    <div class="presencas">{{item.frequencias[0].presencas}}</div>
                                    <em>Meias Presenças</em>
                                    <div class="meias-presencas">{{item.frequencias[0].meia_presenca}}</div>
                                    <em>Faltas</em>
                                    <div class="faltas">{{item.frequencias[0].faltas}}</div>
                                </div>
                                <div class="frequencia-dados">
                                    <em>Frequência</em>
                                    <div class="frequencia">{{item.frequencias[0].frequencia}}%</div>
                                </div>
                            </div>
                        </div>
                        <div class="dados notas" v-if="item.fl_curriculo_competencias == true && !item.fl_cpp && item.fl_fora_matriz == false" >
                          <v-card  elevation="0"class="dados">
                            <div v-for="(matriculas, ref_matricula) in competencias.notas_matriculas_individuais">
                              <div v-if="ref_matricula == item.ref_matricula" v-for="(matricula, dados_ref_curriculo_prova) in matriculas">
                                <div v-for="(descricao, ref_curriculo_prova) in descAvaliacao"> 
                                    <div v-if="ref_curriculo_prova == dados_ref_curriculo_prova">
                                      <v-card-text class="pa-1 ma-0" color="blue-grey lighten-5">
                                        <strong class="descricao-individual">{{ descricao }}</strong>
                                      <div v-for="notas in matricula">
                                        <v-flex sm5>
                                          <strong class="nota-individual">Nota {{ notas.numero  }}:</strong> {{ notas.nota }}
                                      </v-flex>
                                      </div>
                                    </v-card-text>
                                    </div>
                                </div>
                              </div>
                            </div>
                            
                            <div v-if="item.nota_exame">
                               <v-flex class="pa-1 ma-0" sm5>
                                 <strong class="nota-individual">Nota Exame:</strong> {{ item.nota_exame  }}
                              </v-flex>
                            </div>
                            <div v-if="competencias.ref_curriculo_modelo_avaliacao == 3" v-for="media in competencias.medias_matriculas_individuais[item.ref_matricula]">
                              <div class="pa-1 ma-0" color="blue-grey lighten-5">
                                <v-flex sm0>
                                  <div><strong class="descricao-individual">MÉDIA</strong></div>
                                  <strong class="nota-individual">Média Parcial:</strong> {{ (media).toFixed(2) }}
                                </v-flex>
                              </div>
                            </div>
                        </v-card>
                        </div>
                        <div v-else-if="item.fl_curriculo_competencias == false || item.fl_cpp == true" class="dados" color="blue-grey lighten-5">
                            <div
                              class="conteudo" v-bind:class="{'-pos-graduacao' : posGraduacao}">
                                <div class="notas" v-if="posGraduacao">
                                    <em>Conceito</em>
                                    <div class="nota">{{item.conceito1 || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao">
                                    <em>Nota 1</em>
                                    <div class="nota">{{item.nota1 || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao">
                                    <em>Nota 2</em>
                                    <div class="nota">{{item.nota2 || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao">
                                    <em>Nota 3</em>
                                    <div class="nota">{{item.nota3 || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao && !item.media_final">
                                    <em>Média</em>
                                    <div class="nota">{{item.media || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao && item.nota_exame">
                                    <em>Exame</em>
                                    <div class="nota">{{item.nota_exame || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao && item.media_final">
                                    <em>Média Final</em>
                                    <div class="nota">{{item.media_final || '-'}}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="dados" color="blue-grey lighten-5">
                            <div
                              class="conteudo" v-bind:class="{'-pos-graduacao' : posGraduacao}">
                                <div class="notas" v-if="posGraduacao">
                                    <em>Conceito</em>
                                    <div class="nota">{{item.conceito1 || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao">
                                    <em>Nota 1</em>
                                    <div class="nota">{{item.nota1 || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao">
                                    <em>Nota 2</em>
                                    <div class="nota">{{item.nota2 || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao">
                                    <em>Nota 3</em>
                                    <div class="nota">{{item.nota3 || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao && !item.media_final">
                                    <em>Média</em>
                                    <div class="nota">{{item.media || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao && item.nota_exame">
                                    <em>Exame</em>
                                    <div class="nota">{{item.nota_exame || '-'}}</div>
                                </div>
                                <div class="notas" v-if="!posGraduacao && item.media_final">
                                    <em>Média Final</em>
                                    <div class="nota">{{item.media_final || '-'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-dialog v-model="mostrarModalPdf" width="80%">
            <v-card class="modal-pdf">
                <v-card-text>
                    <iframe :src="pdfBase64"></iframe>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModalPdf = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Modal de detalhamento de notas-->
        <v-dialog v-model="mostrarModalDetalheNotas" width="50%" align-center>
          <v-card >
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="mostrarModalDetalheNotas = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>
              <v-card-title class="primary white--text">
                AVALIAÇÕES DA ÁREA TEMÁTICA {{competencias.desc_area_tematica}}
              </v-card-title>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>              
              <template v-if="refMatricula">
                <v-layout justify-center >
                  <v-flex sm6>
                    <h3 align="center">{{ notasMatriculasAvaliacoes['M' + refMatricula].dados.descricao  }}</h3>
                    <p><strong>Professor(a):</strong> {{ notasMatriculasAvaliacoes['M' + refMatricula].dados.professores.replace(/[0-9]+.-/g, '') }} </p>
                  </v-flex>
                </v-layout>
                <v-layout justify="center" align-space-around justify-center row fill-height>
                <div v-if="notasMatriculasAvaliacoes['M' + refMatricula].avaliacoes.length == 0">
                  <h4>Nenhuma nota registrada.</h4>
                </div>
                  <template v-for="avaliacao in notasMatriculasAvaliacoes['M' + refMatricula].avaliacoes">
                    <v-flex sm3>                    
                      <v-card  class="ml-2" cols="2">
                        <v-card-title><strong>{{ avaliacao[0].avaliacao }}</strong></v-card-title>
                        <v-divider></v-divider>
                        <v-list dense>
                          <v-list-tile v-for="nota in avaliacao[0].notas">
                            <v-list-item-content  class="align-end">
                              <strong>Nota {{ nota.numero }}:</strong> {{ nota.nota }}
                            </v-list-item-content>
                          </v-list-tile>
                        </v-list>
                      </v-card>
                    </v-flex>
                </template>                
              </v-layout>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- End Modal de detalhamento de notas -->
        <!-- Modal de Grafico-->
        <v-dialog v-model="mostrarModalGrafico" width="80%" align-center>
          <v-card >
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="mostrarModalGrafico = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>
              <v-card-title class="primary white--text">
                AVALIAÇÕES DA ÁREA TEMÁTICA {{competencias.desc_area_tematica}}
              </v-card-title>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <v-layout row wrap>
                    <v-flex d-flex xs12 sm12 v-for="avaliacao in competencias.avaliacoes">
                      <v-card mx-2>
                        <v-card-title class="primary white--text pa-2">
                          <div class="text-right">
                          {{avaliacao.desc_tipo_prova}}
                          (Peso: {{avaliacao.peso}})
                          </div>
                        </v-card-title>
                        <div>
                          <table class="table-notas" id="dataTableNotas">
                            <tbody>
                              <tr v-for="(nota, key) in avaliacao.notas">
                                <td class="td-label-notas">Nota {{key+1}}</td>
                                <td class="td-notas" :style="(avaliacao.descartada ? (avaliacao.descartada[key+1] ? 'text-decoration: line-through' : '') : '')">
                                {{nota}}
                                </td>
                              </tr>
                              <tr v-if="(avaliacao.quantidade_avaliacao >= avaliacao.notas.length)"
                                v-for="i in (avaliacao.quantidade_avaliacao - avaliacao.notas.length)">
                                <td class="td-label-notas">Nota {{ ++avaliacao.notas.length}}</td>
                                <td class="td-notas"> - </td>
                              </tr>
                              <tr>
                                <td class="td-label-notas"><strong>Média</strong></td>
                                <td class="td-notas">{{avaliacao.media}}</td>
                              </tr>
                            </tbody>
                          </table>
                          <v-card-text class="pa-1" v-if="avaliacao.numero_descarte">
                            <div>
                                <v-chip class="ma-0" color="orange" label outline ><v-icon left> info </v-icon> Nº de notas descartadas {{avaliacao.numero_descarte}}</v-chip>
                            </div>
                          </v-card-text>
                        </div>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 sm12 d-flex>
                      <v-card mt-2>
                        <v-card-title class="primary white--text">
                          <strong>Média Geral: {{competencias.media_final}}</strong>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm8 d-flex>
                  <v-layout row wrap>
                    <v-flex xs12 d-flex>
                      <highcharts :options="chartOptionsMedia" class="charts"></highcharts>
                    </v-flex>
                    <v-flex xs12>
                      <highcharts :options="chartOptionsAvaliacoes" class="charts"></highcharts>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- End Modal de detalhamento de notas -->

        <v-dialog v-model="mostrarModalDetalheFrequencia" width="80%" align-center>
            <v-card-title class="primary white--text">
                <div class="box-header">
                    <div class="box-title">{{refDisciplina}} - {{nomeDisciplina}}</div>
                    <div class="box-nav">
                        <v-menu bottom offset-y id="menu-mostra-legenda">
                            <v-btn flat icon slot="activator" class="primary white--text" ><span class="fas fa-info-circle"></span></v-btn>
                            <v-list>
                                <v-list-tile>
                                    <v-list-tile-title> <span class="span-presenca"><i class="far fa-smile"></i> - Presença</span></v-list-tile-title>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile>
                                    <v-list-tile-title> <span class="span-meia-presenca"><i class="far fa-meh"></i> - Meia Presença</span></v-list-tile-title>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile>
                                    <v-list-tile-title><span class="span-falta">  <i class="far fa-frown"></i> - Falta</span></v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                </div>
            </v-card-title>
            <v-card id="card-modal-detalhe-frequencia">
                <v-container grid-list-xl text-xs-center align-center>
                    <v-layout row wrap>
                        <v-flex v-for="meses in frequencias" sm2 xs12 align-center>
                            <v-card class="primary white--text" hover>
                                <v-card-text class="px-0">
                                    <strong>{{meses.mes_string}}</strong>
                                </v-card-text>
                                <v-list>
                                    <template v-for="(dia, index) in meses.frequencias" locale="pt-br">
                                        <v-list-tile :key="dia.dt_aula + new Date().getTime()">
                                            <v-list-tile-content>
                                                <v-list-tile-title ><strong>{{dia.dia_string}}</strong></v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-avatar v-for="tipo_presenca in dia.tipos_presencas" v-if="tipo_presenca">
                                                <span  v-if="tipo_presenca === 'presenca'" class="span-presenca">
                                                    <i class="far fa-smile"></i>
                                                </span>
                                               <span v-else-if="tipo_presenca ==='meia_presenca'" class="span-meia-presenca">
                                                    <i class="far fa-meh" ></i>
                                               </span>
                                                <span v-else class="span-falta">
                                                    <i class="far fa-frown"></i>
                                                </span>
                                            </v-list-tile-avatar>
                                        </v-list-tile>
                                        <v-divider v-if="(index +1) < meses.frequencias.length"></v-divider>
                                    </template>
                                </v-list>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModalDetalheFrequencia = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style lang="scss" scoped>
    .descricao-individual {
      color: #757575 !important;
      text-decoration: underline !important;
    }
    .nota-individual {
      color: #5e5e5e !important;
      width: 100%;
    }
    .disciplinas-lista {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .disciplina {
            border: 1px solid #e8e8e8;
            border-radius: 4px;
            padding: 20px;
            width: 24%;
            margin: 0 0.5% 20px;

            h3 {
                font-size: 18px;
                font-weight: 500;
                margin: 0 0 15px 0;
                text-align: center;
                padding-bottom: 10px;
                border-bottom: 1px solid #DDD;
            }
            p {
                color: #5e5e5e;
                margin: 0;
                padding: 2px 0;
                font-size: 13px;
            }
            .dados {
                margin-top: 10px;
                background-color: #f3f3f3;
                border-radius: 4px;
                padding: 5px 10px;
                strong {
                    color: #464646;
                }
                .conteudo {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    em {
                        font-size: 12px;
                    }

                    &.-pos-graduacao {
                        justify-content: center;
                        .notas {
                            .nota {
                                font-size: 28px;
                            }
                        }
                    }

                    .frequencia-dados {
                        text-align: center;
                        &:first-child {
                            border-right: 1px solid #DDD;
                            padding-right: 15px;
                            width: 60%;
                        }
                        &:last-child {
                            width: 40%;
                        }
                        .detalhe-frequencia {
                            float: left;
                            width: 1%;
                        }
                    }
                    .meias-presencas,
                    .presencas,
                    .faltas,
                    .frequencia {
                        font-size: 18px;
                        font-weight: bold;
                    }
                    .meias-presencas {
                        color: #FBC02D;
                    }
                    .presencas {
                        color: #057e45;
                    }
                    .faltas {
                        color: #ab4329;
                    }
                    .frequencia {
                        color: #3178ab;
                        font-size: 22px;
                    }
                    .notas {
                        text-align: center;
                        .nota {
                            color: #707070;
                            font-size: 18px;
                            font-weight: 500;
                        }
                        &:last-child {
                            .nota {
                                color: #000;
                                font-size: 22px;
                            }
                        }
                    }
                }
            }
        }
    }

    .plano-ensino-link {
        text-decoration: none;
        color: #E0933F;
        &:hover {
            span {
                text-decoration: underline;
            }
        }
    }

    #card-modal-detalhe-frequencia {
        .layout {
            justify-content: center;
        }
        div.v-avatar {
            width: 20px !important;
        }
        .v-list__tile__avatar {
            display: flex;
            justify-content: flex-start;
            min-width: 20px;
        }
    }

    .span-presenca {
        color: #00C853;
        width: 1px!important;
        white-space: nowrap;
    }
    .span-meia-presenca {
        color: #FBC02D;
        width: 1px!important;
        white-space: nowrap;
    }
    .span-falta {
        color: #FF3D00;
        width: 1px!important;
        white-space: nowrap;
    }

    .box-header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .table-notas {
      width: 100%;
    }
    .table-notas {
        border-collapse: collapse;
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.12);
        thead {
            tr {
                border-bottom: 1px solid rgba(0, 0, 0, 0.12);
                th {
                    padding: 6px 24px;
                    color: #FFF;
                    text-align: center;
                    font-size: 12px;
                    background-color: #465E54;
                }
            }
        }
        tbody {
            tr {
                border-bottom: 1px solid rgba(0, 0, 0, 0.12);
                transition: all .3s ease-in-out;
                &:last-child {
                    border-bottom: none;
                }
                &:hover {
                    background-color: #f1f1f2;
                }
                td {
                    padding: 3px 20px;
                    font-size: 12px;
                    height: 36px;
                    letter-spacing: -0.02em;
                }
                .td-label-notas {
                  font-weight: bold;
                }
                .td-notas {
                  text-align: center;
                }
            }
        }
        th, td {
            &.horario {
                padding-left: 6px;
                padding-right: 6px;
            }
        }
    }
    .v-expansion-panel__container:first-child {
      border-top: 1px solid rgba(166, 166, 166, 0.653) !important;
    }

    @media all and (max-width: 1350px) {
        .disciplinas-lista {
            .disciplina {
                width: 32%;
            }
        }
    }

    @media all and (max-width: 1080px) {
        .disciplinas-lista {
            .disciplina {
                width: 49%;
            }
        }
    }

    @media all and (max-width: 620px) {
        .disciplinas-lista {
            .disciplina {
                width: 100%;
                margin: 0 0 15px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// FrequenciaNotas.vue?4b9a0939